import styled from '@emotion/styled'
import Link from 'next/link'

export const LinkWithoutDecoration = styled.a`
  text-decoration: none;
`

export const NextLinkWithoutDecoration = styled(Link)`
  text-decoration: none;
  color: inherit;
`
